import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Callout from './Callout';

import './styles/generic-error.scss';

const GenericError = (props) => {
    const { contextCls } = props;
    const baseCls = 'fluid-generic-error';

    return (
        <Callout
            {...props}
            iconCls="fluid-icon-exclamation-triangle"
            contextCls={cx(baseCls, contextCls)}
        />
    );
};

GenericError.defaultProps = {};

GenericError.propTypes = {
    contextCls: PropTypes.string,
};

export default GenericError;
